<template lang="pug">
	include additionAlteration.pug
</template>

<script>
import uploadPopUp from '@/commonSite/uploadFiles'
import _ from 'lodash'
// import _price from '@/commonSite/prices'

export default {
	name: 'existing-plus-additions-commercial',
	components: {
		uploadPopUp
	},
	data: function () {
		return {
			sqft: '',
			status: 'not_accepted',
			NofUnique: '',
			checkedNames: [],
			comp: {
				optEnvelope: false,
				optLighting: false,
				optMechanical: false
			},
			lowPerfCommEstimate: '',
			hiPerfCommEstimate: '',
			lowPresCommEstimate: '',
			hiPresCommEstimate: '',
			commExstFloor: '',
			commAdtnFloor: '0',
			multiplier: 1
			// .. price: _price
			// price: {}
		}
	},
	created () {
		this.price = this.$e24Common.storageService.findItem('config', true).estimator
	},
	methods: {
		// fn called in change of new Building field
		findBySku (sku) {
			return _.find(this.products, { sku: sku.toString() })
		},
		calcCommercialEst () {
			// console.debug('calcCommercialEst have been called!')
			if (this.commNewFloor > 0) {
				this.commAdtnFloor = this.commNewFloor
			}
			if (this.validateNumber(this.commExstFloor) === false ||
				this.validateNumber(this.commAdtnFloor) === false) {
				return
			}
			this.commNewFloor = ''

			// Components selected
			this.numComponents = _.reduce(this.comp, function (total, comp) {
				return (comp) ? ++total : total
			}, 0)
			console.debug(`this.numComponents is ${this.numComponents}`)

			this.totalEstimate = 0

			// First calculate the floor area
			let floorArea = this.calculateFloorArea()

			let numComponents = this.numComponents
			let calcPerf
			let totalEstimate
			let preTotalEstimate
			let hvacOnly
			// ------------------------------------------------------
			if (floorArea > 0) {
				floorArea = (floorArea >= 500) ? floorArea : 500

				if (this.comp.optMechanical && (!this.comp.optLighting && !this.comp.optEnvelop)) {
					hvacOnly = true
				} else {
					hvacOnly = false
				}
				// On Commercial projects, the Performance Approach
				// cannot be done on lighting alone.
				if (this.comp.optLighting && (!this.comp.optEnvelope && !this.comp.optMechanical)) {
					alert('The Performance Approach cannot be done on lighting alone')
					console.log('The Performance Approach cannot be done on lighting alone')
					// Don't calculate Performance approach only Prescriptive
					calcPerf = false
					this.clearPerfTotals('N/A')
				} else if (numComponents >= 1) {
				// Calculate Performance and Prescriptive approach
					calcPerf = true
					if (numComponents >= 2) {
						hvacOnly = false
					}
				} else {
				// No component selected then can't calculate
					// $window.alert('Please select type of work to be performed')
					alert('Please select type of work to be performed')
					console.log('Please select type of work to be performed')
					this.clearPerfTotals(0)
					this.clearPresTotals(0)
					return
				}

				// Only if we must do the calculation for Performance
				if (!hvacOnly) {
					switch (numComponents) {
					case 1:
						totalEstimate = this.calculatePerformanceCost(1, floorArea)
						preTotalEstimate = this.calculatePrescripriveCost(1, floorArea)
						break
					case 2:
						totalEstimate = Math.floor((this.calculatePerformanceCost(1, floorArea) + this.calculatePerformanceCost(3, floorArea)) / 2)
						preTotalEstimate = Math.floor((this.calculatePrescripriveCost(1, floorArea) + this.calculatePrescripriveCost(3, floorArea)) / 1.9)
						break
					case 3:
						totalEstimate = this.calculatePerformanceCost(3, floorArea)
						preTotalEstimate = this.calculatePrescripriveCost(3, floorArea)
						break
					}
					if (calcPerf) {
						this.lowPerfCommEstimate = totalEstimate - this.price.comm.estmOffset
						this.hiPerfCommEstimate = totalEstimate + this.price.comm.estmOffset
					}
					this.lowPresCommEstimate = preTotalEstimate - this.price.comm.estmOffset
					this.hiPresCommEstimate = preTotalEstimate + this.price.comm.estmOffset
				} else {
					totalEstimate = Math.floor(((this.calculatePerformanceCost(1, floorArea) + this.calculatePerformanceCost(3, floorArea)) / 2) * 0.88)
					preTotalEstimate = Math.floor(((this.calculatePrescripriveCost(1, floorArea) + this.calculatePrescripriveCost(3, floorArea)) / 1.9) * 0.88)

					this.lowPerfCommEstimate = (this.multiplier * totalEstimate) - (this.price.comm.estmOffset)
					this.hiPerfCommEstimate = (this.multiplier * totalEstimate) + (this.price.comm.estmOffset)
					this.lowPresCommEstimate = (this.multiplier * preTotalEstimate) - (this.price.comm.estmOffset)
					this.hiPresCommEstimate = (this.multiplier * preTotalEstimate) + (this.price.comm.estmOffset)
				}

				// Prescripte
				// let approachCost = this.price.comm.prescAppr[numComponents]
				// totalEstimate = Math.max(this.price.comm.newBuildingBase,Math.round(Math.log(floorArea / 170) * approachCost - this.price.comm.estmOffset));
				// totalEstimate = Math.floor(Math.log(floorArea / 170) * approachCost - this.price.comm.estmOffset)
				// this.lowPresCommEstimate = totalEstimate
				// this.hiPresCommEstimate = totalEstimate + (this.price.comm.estmOffset * 2)
			} else {
			// No floor area
				this.clearPerfTotals(0)
				this.clearPresTotals(0)
			}
		},
		// calculate Performance approach based on the number of
		// components selected only 1 and 3, because 2 components
		// calculation is the average of 1 and 3
		calculatePerformanceCost (numComp, flArea) {
			let total = 0
			switch (numComp) {
			case 1:
				// INT(LN(Flarea/160)*285) + 50
				total = Math.floor(Math.log(flArea / 160) * this.price.comm.perfAppr[1]) + 50
				break
			case 3:
				// INT((140*((Flarea/3000)+1.5)) + (LN(Flarea/160)*365))
				total = Math.floor((140 * ((flArea / 3000) + 1.5)) + (Math.log(flArea / 160) * this.price.comm.perfAppr[3]))
				break
			}
			return total
		},
		calculatePrescripriveCost (numComp, flArea) {
			let total = 0
			switch (numComp) {
			case 1:
				// INT(LN(Flarea/140)*177) + 50
				total = Math.floor(Math.log(flArea / 140) * this.price.comm.prescAppr[1]) + 50
				break
			case 3:
				// INT((140*((Flarea/3000)+1.5)) + (LN(Flarea/160)*288))
				total = Math.floor((140 * ((flArea / 3000) + 1.5)) + (Math.log(flArea / 160) * this.price.comm.prescAppr[3]))
				break
			}
			return total
		},
		clearPerfTotals (clearVal) {
			// Clear performance aproach estimate
			this.lowPerfCommEstimate = clearVal
			this.hiPerfCommEstimate = clearVal
		},
		// Clear prescriptive aproach estimate
		clearPresTotals (clearVal) {
			this.lowPresCommEstimate = clearVal
			this.hiPresCommEstimate = clearVal
		},
		chkComp (wichCheck) {
			this.comp[wichCheck] = !this.comp[wichCheck]
			this.calcCommercialEst()
			console.debug(`have been wichCheck ${wichCheck} ${this.comp[wichCheck]}`)
		},
		validateNumber (anInput) {
			let reg = new RegExp('^[0-9]*$', 'g') // this only detect numbers
			// let reg2 = new RegExp('^-?\d*(\.\d+)?$') // this detects .0 and -9
			if (!reg.test(anInput)) {
				return false
			} else {
				return true
			}
		},
		// return floor area depending on values entered by user
		calculateFloorArea () {
			console.debug('calculateFloorArea have been called!')
			let floorArea = 0
			// Set the area
			if (this.commExstFloor > 0) {
				floorArea = parseFloat(this.commExstFloor) + parseFloat(this.commAdtnFloor)
			}
			return floorArea
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/complianceWizard/commercialWizards/additionAlteration.vue